import React, { useEffect, useState } from 'react';
import "../assets/css/custom.css";
import "../assets/css/client.css";
import "../assets/css/management.css";
import "../assets/css/font-awesome.css";
import "../assets/css/sweetalert.css";
import "../assets/css/bootstrap.min.css";
import "../assets/css/steps.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faMagnifyingGlass,} from "@fortawesome/free-solid-svg-icons";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { commonAPI } from "../services/CommonAPIService";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ErrorSource } from "../common/constants";
import Table from 'react-bootstrap/Table';
import "../assets/css/report.css";
import 'react-toastify/dist/ReactToastify.css';
import 'jspdf-autotable'; 
import Select from "react-dropdown-select";




function AccessManagement() {
  const [loading, setLoading] = useState(false);
  const [UserData, setUserData] = useState(false);

  // states for tower
  const [GateId, setGateId] = useState("");
  const [gateList, setGateList] = useState([])

  // states for tower
  const [towerId, setTowerId] = useState("");
  const [towerList, setTowerList] = useState([])

  // state for flat
  const [flatList, setFlatList] = useState([]);
  const [flatListComplainee, setFlatListComplainee] = useState([]);
  const [flatListId, setFlatListId] = useState("");
  const [flatComplaineeId, setFlatComplaineeId] = useState("");

  const [AccessList, setAccessList] = useState([]);
  const [OldAccessList, setOldAccessList] = useState([]);
  const [AccessSelectList, setAccessSelectList] = useState([]);
  const [WithoutAccessList, setWithoutAccessList] = useState([]);
  const [OldWithoutAccessList, setOldWithoutAccessList] = useState([]);
  const [WithoutSelectAccessList, setWithoutSelectAccessList] = useState([]);
  const [DeleteShow, setDeleteShow] = useState(false);
  const [SearchData, setSearchData] = useState([]);
  console.log("AccessList",  AccessSelectList, WithoutSelectAccessList);
  console.log("FlatListId", flatListId)


  const GetGateList = async () => {
      try {
        console.log("it is run")
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        setUserData(myUserData);
        setLoading(true);
        
          const endPointVariableKey    = {
            urlVariable:null,
            buildingId: myUserData?.buildingId
        
          }
          let response = await commonAPI("Gate", undefined, endPointVariableKey)
          if (response?.success === true) {
            
            const filteredGates = response.data.filter(gate => gate.gateSubType && gate.gateSubType.toUpperCase() === "WALKIN" && gate.accessControlPrimeFactor && ![0, 1].includes(gate.accessControlPrimeFactor));
            console.log("Table Gate", response, filteredGates);
            setGateList(filteredGates);
            setLoading(false);
          } else {
            toast.error("Something went wrong");
            setLoading(false);
          }
        
      } catch (error) {
        console.log(error);
        setLoading(false);
        const bodyError = { 
            "userId": UserData?.userId,
            "mobileNumber": UserData?.mobileNumber,
            "requestJSON": null,
            "uri": "api/Master/Gate",
            "errorNumber": "GL01",
            "errorSource": ErrorSource,
            "errorSummary": error.message,
            "errorDescription": error.message,
            "fileClassName": "Gate.js",
            "functionName": "GetGateList",
        };
        let response = await commonAPI("ErrorLogMaster", bodyError);
        console.log("statusCode", response);
        if (response?.success == true && response?.message?.length == 0) {
            toast.error("Something went wrong");
            setLoading(false);
        } else {
            setLoading(false);
            toast.error("Something went wrong");
        }
      }
  };
  
  const GetTowerList = async () => {
        try {
            // let myBuildingId;
            const auth = localStorage.getItem("userData");
            const myUserData = JSON.parse(auth);
            setUserData(myUserData);
            setLoading(true);

            const endPointVariableKey = {
                buildingId:myUserData?.buildingId
            }

            let response = await commonAPI("Tower", undefined, endPointVariableKey);
            if (response?.success===true){
                console.log("Table Tower", response)
                setTowerList(response?.data);
                setLoading(false);
            }else{
                toast.error("Something went wrong");
                setLoading(false);
            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = JSON.stringify({ 
                "userId": UserData?.userId,
                "mobileNumber": UserData?.mobileNumber,
                "requestJSON": null,
                "uri": "api/Master/Tower",
                "errorNumber": "TL01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "tower.js",
                "functionName": "GetTowerList",
            });
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message?.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }
  }

  const GetFlatList = async () => {
  
    try {
        setLoading(true);
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        const endPointVariableKey    = {
            urlVariable:null,
            buildingId: myUserData?.buildingId
        
        }
        let response = await commonAPI("Flat", undefined, endPointVariableKey);
        if (response?.success===true){
            const tempData = response?.data.filter((item)=> item?.towerId == towerId)
            setFlatList(tempData);
            setLoading(false);
        }else{
            toast.error("Something went wrong");
            setLoading(false);
        }

    } catch (error) {
        console.log(error);
        setLoading(false);
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        // console.log(myUserData)
        setUserData(myUserData);
        console.log("UserData", UserData)
        const bodyError = JSON.stringify({ 
            "userId": UserData?.userId,
            "mobileNumber": UserData?.mobileNumber,
            "requestJSON": null,
            "uri": "/api/Master/Flat",
            "errorNumber": "GF01",
            "errorSource": ErrorSource,
            "errorSummary": error.message,
            "errorDescription": error.message,
            "fileClassName": "flat.js",
            "functionName": "getFlatList",
        });
        let response = await commonAPI("ErrorLogMaster", bodyError);
        console.log("statusCode", response);
        if (response?.success == true && response?.message?.length == 0) {
            toast.error("Something went wrong");
            setLoading(false);
        } else {
            setLoading(false);
            toast.error("Something went wrong");
        }
    }
  
  }  

  useEffect(() => {
    GetGateList();
    GetTowerList();
   }, []);

   useEffect(() => {
    if(towerId){
      GetFlatList();
    }
   }, [towerId]);

   const GetResidingResident = async () => {
      const auth = localStorage.getItem("userData");
      const myUserData = JSON.parse(auth);
      const bodyData    = {
          // "buildingId": myUserData?.buildingId,
          "towerId": towerId ? parseInt(towerId) : null,
          "flatId": flatListId ? parseInt(flatListId) : null,
          "gateId": GateId ? parseInt(GateId) : null,
          // "isResiding": true
      }
      try {
        if(!GateId){
        toast.warning("Please select Gate");
        return;
        }
        if(!towerId){
        toast.warning("Please select Tower");
        return;
        }
        setLoading(true);
          const endPointVariableKey    = {
            urlVariable:null,
            buildingId: myUserData?.buildingId
        
        }
      
          console.log("BodyData", bodyData);
          let response = await commonAPI("UserGateMappingPortal", bodyData, endPointVariableKey)
          console.log("UserGateMappingPortal", response, bodyData);
          if (response?.success === true) {
              if(response?.success === true && response?.data?.length == 0){
                  toast.warning("No data found");
                  setAccessList([]);
                  setWithoutAccessList([]);
                  setWithoutSelectAccessList([]);
                  setAccessSelectList([]);
                  setLoading(false);
              }else{
                // const filteredData = response?.data.filter(item => item.primeGateMultiFactorCode !== null && (item.primeGateMultiFactorCode && GateId && item.primeGateMultiFactorCode % GateId === 0));
                // setAccessList(filteredData);
                // setOldAccessList(filteredData);
                // setWithoutAccessList(response?.data.filter(item => !filteredData.includes(item)));
                // setOldWithoutAccessList(response?.data.filter(item => !filteredData.includes(item)));
                // console.log("setAccessList", filteredData, GateId, response?.data.filter(item => !filteredData.includes(item)));
                const accessList = response?.data?.filter(item => item?.gateId != null);
                const withoutAccessList = response?.data?.filter(item => item?.gateId == null);

                setAccessList(accessList);
                setOldAccessList(accessList);
                setWithoutAccessList(withoutAccessList);
                setOldWithoutAccessList(withoutAccessList);
                setWithoutSelectAccessList([]);
                setAccessSelectList([]);
                setLoading(false);
              }
              setLoading(false);
          } else {
              toast.warning(response?.message[0]);
              setLoading(false);
          }

        
      } catch (error) {
        console.log(error);
        setLoading(false);
        const bodyError = { 
            "userId": myUserData?.userId,
            "mobileNumber": myUserData?.mobileNumber,
            "requestJSON": bodyData,
            "uri": "/api/Report/WalkinVisitorInOutReport",
            "errorNumber": "WR01",
            "errorSource": ErrorSource,
            "errorSummary": error.message,
            "errorDescription": error.message,
            "fileClassName": "Report.js",
            "functionName": "GetGateList",
        };
        let response = await commonAPI("ErrorLogMaster", bodyError);
        console.log("statusCode", response);
        if (response.success == true && response.message.length == 0) {
            toast.error("Something went wrong");
            setLoading(false);
        } else {
            setLoading(false);
            toast.error("Something went wrong");
        }
      }
    };

    useEffect(() => {
      if (GateId && towerId) {
        GetResidingResident();
      } else {
        setAccessList([]);
        setWithoutAccessList([]);
        setAccessSelectList([]);
        setWithoutSelectAccessList([]);
      }
    }, [towerId, flatListId]);

    function filterAccessData(text) {
      setSearchData(text);
      const oldData = OldAccessList;
      const oldDataWithout = OldWithoutAccessList;
      console.log(text.toLowerCase());

      // Filter the AccessList based on specific properties
      let newData = oldData.filter((item) => {
      return item.userName?.toLowerCase().includes(text.toLowerCase());
      });

      // Filter the WithoutAccessList based on specific properties
      let newDataWithout = oldDataWithout.filter((item) => {
      return item.userName?.toLowerCase().includes(text.toLowerCase());
      });

      setAccessList(newData); // Update the state with the filtered AccessList
      setWithoutAccessList(newDataWithout); // Update the state with the filtered WithoutAccessList
    }

  const GetMappingUser = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        const bodyData    = {
            "gateId": parseInt(GateId),
            "lstAddUserGateMapping": WithoutSelectAccessList ? WithoutSelectAccessList : null,
            "lstDeleteUserGateMapping": AccessSelectList ? AccessSelectList : null,
            "createdUserId": myUserData?.userId.toString(),
          }
           
        try {
          if(!GateId){
           toast.warning("Please select Gate");
           return;
          }

            if(!AccessSelectList.length && !WithoutSelectAccessList.length){
            toast.warning("Please select User");
            return;
             }

          const endPointVariableKey    = {
            urlVariable:null,
            buildingId: myUserData?.buildingId
        
        }
          
          setLoading(true);
          
        
            console.log("BodyData", bodyData);
            let response = await commonAPI("UserGateMapping", bodyData, endPointVariableKey)
            console.log("UserGateMapping", response, bodyData);
            if (response?.success === true) {
              toast.success("Access Updated Successfully");
              GetResidingResident()
              setDeleteShow(false);
              setWithoutSelectAccessList([]);
              setAccessSelectList([]);
              setLoading(false);
            } else {
                toast.warning(response?.message[0]);
                setLoading(false);
            }

          
        } catch (error) {
          console.log(error);
          setLoading(false);
          const bodyError = { 
              "userId": myUserData?.userId,
              "mobileNumber": myUserData?.mobileNumber,
              "requestJSON": bodyData,
              "uri": "/api/Report/WalkinVisitorInOutReport",
              "errorNumber": "WR01",
              "errorSource": ErrorSource,
              "errorSummary": error.message,
              "errorDescription": error.message,
              "fileClassName": "Report.js",
              "functionName": "GetGateList",
          };
          let response = await commonAPI("ErrorLogMaster", bodyError);
          console.log("statusCode", response);
          setLoading(false);
          toast.error("Something went wrong");
        }
    };

    const towerOptions = towerList
    ? towerList.map(item => ({
        value: item.towerId,
        label: item.towerName ? String(item.towerName) : 'Unnamed',
      }))
    : [];

  const flatOptions = flatList
    ? flatList.map(item => ({
        value: item.flatId,
        label: item.flatName ? String(item.flatName) : 'Unnamed',
      }))
    : [];

  return (
    <>
      {loading ?
        <div className="loaderDiv">
          <div className="loader"></div>
        </div>
        : null}

      <ToastContainer />

      {/* <style>
        {`.css-1680m6m-DropDown {
            width: 200px;
        }
        
        .css-wmy1p7-ReactDropdownSelect{
            font-size: 13px;
            border-color: #ccc;
            border-radius: 4px;
            height: 40px;
            width: 139px;
            background-color: #fff;
            text-align: left;
        }`
        
        }
        </style> */}
      
      <div className="row mb-1">
        <div className="col-md-3 mt-5 pt-2">
          <div className="HeadingTop">
            <h3> Access Management </h3>
            <span style={{whiteSpace: "nowrap"}}> Monitor, track, and control entry permissions for residents, visitors, and service staff. </span>
          </div>
        </div>
        <div className="col-md-9 text-right mt-5 pt-2" style={{ alignContent: 'center' }}>
          <div className='row justify-content-end'>



                <div className='col-lg-6 col-md-6 col-sm-12 col-12 pr-0' style={{display: "ruby"}}>
              <select size="md" style={{width: 150}} className="accessareamodal hdesk ml-auto bg-white" value={GateId} onChange={(e) => {setGateId(e.target.value); setTowerId(""); setFlatListId(""); setFlatList([])}}>
            <option value="">Access Gate</option>
            {gateList.map((item, index) => {
              return (
                <option key={index} value={item.gateId}>{item.gateName}</option>
              )
            })}

            </select>{" "}
            <Select
    searchable={true}
    clearable={towerId ? true : false}
    options={towerOptions}
    labelField="label"
    valueField="value"
    className=""
    placeholder="Select Tower"
    values={towerId ? towerOptions.filter(option => option.value === towerId) : []}
    onChange={(selectedOptions) => {
        const selectedId = selectedOptions && selectedOptions.length > 0 ? selectedOptions[0].value : '';
        setTowerId(selectedId);
        setFlatListId(""); // Clear selected flat value when tower changes
        setFlatList([]);   // Clear flat list as well
    }}
    searchBy="label"
    style={{
        fontSize: '13px',
        borderColor: '#ccc',
        borderRadius: '4px',
        height: '39px',
        width: '150px',
        backgroundColor: '#fff',
        textAlign: 'left',
        marginRight: 10
    }}
    dropdownStyle={{
        width: '200px',
    }}
/>

<Select
    searchable={true}
    clearable={flatListId ? true : false}
    options={flatOptions}
    labelField="label"
    valueField="value"
    className=""
    placeholder="Select Flat"
    values={flatListId ? flatOptions.filter(option => option.value === flatListId) : []}
    onChange={(selectedOptions) => {
        setFlatListId(selectedOptions && selectedOptions.length > 0 ? selectedOptions[0].value : '');
    }}
    searchBy="label"
    style={{
        fontSize: '13px',
        borderColor: '#ccc',
        borderRadius: '4px',
        height: '39px',
        width: '140px',
        backgroundColor: '#fff',
        textAlign: 'left',
    }}
    dropdownStyle={{
        width: '200px',
    }}
/>

        
               
            {/* <select size="md" className="accessareamodal hdesk ml-auto bg-white" value={flatListId}  onChange={(e) => {setFlatListId(e.target.value)}}>
              <option value="">All Flat</option>
              {flatList.map((item, index) => {
              return (

                <option key={index} value={item.flatId}>{item.flatName}</option>
              )
              })}

            </select> */}
              </div>
              
              {/* <Select
              isMulti
              size="md"
              className="accessmanag__multiselect px-0" 
              value={flatList.filter(item => flatListId.includes(item.flatId)).map(item => ({ value: item.flatId, label: item.flatName }))}
              onChange={(selectedOptions) => {
                const selectedValues = selectedOptions.map(option => option.value);
                setFlatListId(selectedValues);
              }}
              options={flatList.map((item) => ({
                value: item.flatId,
                label: item.flatName
              }))}
            />{""}  */}
                
              {/* <div className='col-lg-1 col-md-1 col-sm-12 col-12'>

            <Button onClick={GetResidingResident} className="createClr" style={{height:'39px'}} >
            Go
            </Button>{" "}  
            </div> */}



          </div>



          {/* {AccessList.length || WithoutAccessList.length ? */}
              <div className="search_access">
                <input type="text" placeholder="Search here" value={SearchData} onChange={(e) => filterAccessData(e.target.value)}/>
                <FontAwesomeIcon icon={faMagnifyingGlass} className="search_access_icon"/>
              </div>
          {/* :null}     */}

        </div>
      </div>
      

      <div className="row mb-3" style={{ alignItems: 'center' }}>
        <div className="col-lg-6 col-md-6 col-sm-12 col-12 pr-0">
            <div className='access_type_text'>
                <span>User with access :  </span>
                <label> {AccessList.length} </label>
            </div>
        
            <div className="container-fluid mt-3">
                        <div className="row mt-2 ">
                            <div className="tableFixHead">
                            
                            <div className="scrolling_tbl" style={{height: 'auto',overflow:'hidden'}} >
                            
                                <Table striped responsive className="mb-0">
                <thead>
                    <tr>
                        <th> Name</th>
                        <th> Flats </th>
                    </tr>
                </thead>
                <tbody> 
                {AccessList.map((item, index) => (
                  <tr key={index} className={item.checked ? "bg_color_red" : "bg_color_green"}>
                    <td className='nodt'>
                      <input type="checkbox" className="pcheck" name="ClipListCheckbox" checked={item.checked} onChange={() => {
                        const updatedAccessList = [...AccessList];
                        updatedAccessList[index].checked = !updatedAccessList[index].checked;
                        setAccessList(updatedAccessList);
                        if (updatedAccessList[index].checked) {
                        setAccessSelectList(prev => [...prev, { userMappingId: item.userMappingId }]);
                        } else {
                        setAccessSelectList(prev => prev.filter(obj => obj.userMappingId !== item.userMappingId));
                        }
                      }} />
                    <span> {item?.userName} </span>
                    </td>
                    <td className='nodt'> {`${item?.towerName} - ${item?.flatName}`} </td>
                  </tr>
                  ))}
                        
                </tbody>

              </Table>
              
              </div>
 
</div>
            </div>
          </div>
 
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
        <div className='access_type_withouttext'>
                <span>User without access :  </span>
                <label> {WithoutAccessList.length} </label>
            </div>



            <div className="container-fluid mt-3">
                        <div className="row mt-2 ">
                            <div className="tableFixHead">
                            
                            <div className="scrolling_tbl" style={{height: 'auto',overflow:'hidden'}} >
                            
                              
                            <Table striped responsive className="mb-0">

                <thead>
                  <tr>

                    <th >Name</th>
                    <th > Flats </th>

                  </tr>
                </thead>
                <tbody> 
                   
                       {WithoutAccessList.map((item, index) => (
                        <tr key={index} className={item.checked ? "bg_color_green" : "bg_color_red"}>
                          <td className='nodt'>
                            <input type="checkbox" className="pcheck" name="ClipListCheckbox" checked={item.checked} onChange={() => {
                              const updatedWithoutAccessList = [...WithoutAccessList];
                              updatedWithoutAccessList[index].checked = !updatedWithoutAccessList[index].checked;
                              setWithoutAccessList(updatedWithoutAccessList);
                              if (updatedWithoutAccessList[index].checked) {
                                setWithoutSelectAccessList(prev => [...prev, { userMappingId: item.userMappingId }]);
                              } else {
                                setWithoutSelectAccessList(prev => prev.filter(obj => obj.userMappingId !== item.userMappingId));
                              }
                            }} />
                            <span> {item?.userName} </span>
                          </td>
                          <td className='nodt'> {`${item?.towerName} - ${item?.flatName}`} </td>
                        </tr>
                      ))}
                      
                </tbody>

              </Table>
              
              </div>
</div>
            </div>
          </div>

        </div>
        <div className="col-lg-12 col-md-12 col-sm-12 col-12">
        <div className="align-self-start bg-white d-flex flex-row-reverse py-2" style={{height: "50px"}}>
         
                  {AccessSelectList.length || WithoutSelectAccessList.length ?
                  <button type="button" className="btn  btn-info" onClick={() => {
                    if (!GateId) {
                      toast.warning("Please select Gate");
                      return;
                    }
                    if (!AccessSelectList.length && !WithoutSelectAccessList.length) {
                      toast.warning("Please select User");
                      return;
                    }
                    setDeleteShow(true);
                  }}> Preview </button>
                  :null
                } 

                 {AccessSelectList.length || WithoutSelectAccessList.length ?
              <button type="button" className="btn border bg-white" onClick={() => {
                        const updatedAccessList = AccessList.map(item => ({ ...item, checked: false }));
                        const updatedWithoutAccessList = WithoutAccessList.map(item => ({ ...item, checked: false }));
                        setAccessList(updatedAccessList);
                        setWithoutAccessList(updatedWithoutAccessList);
                        setAccessSelectList([]);
                        setWithoutSelectAccessList([]);
                        }}> Reset </button>
              :null
            }          
                </div>
                </div>
      </div>

      <Modal centered show={DeleteShow} onHide={() =>
            setDeleteShow(false)} dialogclassName="modal-100w" aria-labelledby="contained-modal-title-vcenter ">
            <Modal.Body className='p-0' style={{borderRadius: "10px", overflow: "hidden"}}>
                <div className="row px-3" id="validation">
                    <div className="col-12 bg-white pt-3 pb-2">
                    <div className="FnFtxt">
                                <h2>Update User Access  </h2>
                                <h6>Update user access to ensure secure permissions, enable role-based control, and enhance system efficiency seamlessly.</h6>
                            </div>
                        <div className="FnFItem" style={{justifyContent: "space-between"}}>
                            
                            <div className="FnFtxt">
                                <h3>Grant Access  Count: {WithoutSelectAccessList.length}   </h3>
                            </div>
                            <div className="FnFtxt">
                                <h3>Revoke Access  Count: {AccessSelectList.length}   </h3>
                            </div>
                        </div>
                        
                    </div>
                    
                </div>
                <div className='confirmation_btn pb-4 pt-3 px-3' style={{justifyContent: "center", borderTop: "1px solid #dadada"}}>
                        <div className='both_ConfrmBTN col-6' onClick={GetMappingUser}>
                            <Button variant="danger">Confirm</Button>{' '}
                        </div>
                        <div className='both_ConfrmBTN col-6' onClick={() => setDeleteShow(false)} >
                            <Button variant="light"> Cancel</Button>{' '}
                        </div>
                    </div>
            </Modal.Body>
        </Modal>

      
    </>
  );
}
export default AccessManagement;